export enum AnalyticsSource {
  KEY = 'source',
  VALUE_WEB = 'web',
  VALUE_APP = 'app'
}

export const COMMON_ATTRIBUTES = {
  PAGE_NAME: 'pageName',
  PAGE_URL: 'pageURL',
  DEVICE_TYPE: 'deviceType',
  PLATFORM: 'platform',
  DEVICE_OS: 'deviceOs',
  BROWSER: 'browser',
  OS_VERSION: 'OSVersion',
  REF_NAME: 'refName',
  CHECKOUT_ID: 'checkoutId',
  STORE_ID: 'storeId',
  ZIPCODE: 'zipCode',
  HAS_MMID: 'hasMMID',
  USER_ID: 'userId'
};

export type JSONArray = Array<JSONValue>;

export type JSONValue = string | number | boolean | JSONObject | JSONArray;

export interface JSONObject {
  [key: string]: JSONValue;
}
export interface AnalyticsData {
  sourceEvent: string;
  triggerType: string;
  productId: string;
  productPrice: string | number;
  qty: number;
}
